import { useState } from 'react';
import { createBooking } from '../services/bookings';
import { notifyNewEnquiry } from '../services/emailNotifications';
import './forms.css';

export default function BookingRequestForm({ initialValues = {}, roomName = '' }) {
  const [notice, setNotice] = useState('');
  const [sending, setSending] = useState(false);

  async function submitRequest(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);
    const checkIn = data.get('checkIn');
    const checkOut = data.get('checkOut');

    if (checkOut <= checkIn) {
      setNotice('Check-out must be later than check-in.');
      return;
    }

    const whatsapp = String(data.get('whatsapp') || '').trim();
    const request = String(data.get('request') || '');
    const savedRequest = whatsapp
      ? `${request}${request ? '\n\n' : ''}WhatsApp number: ${whatsapp}`
      : request;

    setSending(true);
    setNotice('');
    try {
      await createBooking({
        room_name: roomName,
        check_in: checkIn,
        check_out: checkOut,
        guests: Number(data.get('guests')) || 1,
        name: data.get('name'),
        email: data.get('email'),
        phone: data.get('phone'),
        request: savedRequest
      });
      notifyNewEnquiry({
        name: data.get('name'),
        email: data.get('email'),
        phone: data.get('phone'),
        whatsapp,
        room: roomName,
        checkIn,
        checkOut,
        guests: Number(data.get('guests')) || 1,
        request
      });
      form.reset();
      setNotice('Thank you! Your booking enquiry has been sent. We will confirm availability shortly.');
    } catch (error) {
      setNotice(`Could not send your request: ${error.message}`);
    } finally {
      setSending(false);
    }
  }

  return (
    <form className="site-form" onSubmit={submitRequest}>
      {roomName && <p className="form-context">Enquiry for: {roomName}</p>}
      <div className="form-grid">
        <label className="form-field">
          <span>Check-in</span>
          <input type="date" name="checkIn" defaultValue={initialValues.checkIn || ''} required />
        </label>
        <label className="form-field">
          <span>Check-out</span>
          <input
            type="date"
            name="checkOut"
            min={initialValues.checkIn || undefined}
            defaultValue={initialValues.checkOut || ''}
            required
          />
        </label>
        <label className="form-field">
          <span>Guests</span>
          <input
            type="number"
            name="guests"
            min="1"
            step="1"
            defaultValue={initialValues.guests || '1'}
            required
          />
        </label>
        <label className="form-field">
          <span>Name</span>
          <input type="text" name="name" autoComplete="name" required />
        </label>
        <label className="form-field">
          <span>Email</span>
          <input type="email" name="email" autoComplete="email" required />
        </label>
        <label className="form-field">
          <span>Phone</span>
          <input type="tel" name="phone" autoComplete="tel" required />
        </label>
        <label className="form-field form-field-wide">
          <span>WhatsApp number <em>(optional, if different from phone)</em></span>
          <input type="tel" name="whatsapp" placeholder="+94 7X XXX XXXX" />
        </label>
        <label className="form-field form-field-wide">
          <span>Special request <em>(optional)</em></span>
          <textarea name="request" rows="4" />
        </label>
      </div>
      <button className="button button-gold" type="submit" disabled={sending}>
        {sending ? 'Sending…' : 'Send booking enquiry'}
      </button>
      <p className="form-disclaimer">
        Requests are not confirmed until the guest house confirms availability.
      </p>
      {notice && <p className="form-status" role="status">{notice}</p>}
    </form>
  );
}